export default __webpack_public_path__ + "images/6f4b4f54eec247374fdfe64f75fcd6b3.png";